module.exports = __webpack_public_path__ + "static/desktop-footer-8dbc2336b818a5beb11595d69fa7979d.jpg";